<script setup>
import StatusItem from '../components/StatusItem.vue'
import icons from '../icons'

defineProps({
  level: {
    type: [Number, String],
    default: null,
  },
  status: {
    type: String,
    default: null,
  },
})

const formatBatteryLevel = (level) => {
  if (level === undefined || level === null) return 'Onbekend'
  return `${level}%`
}

const getBatteryColor = (level) => {
  if (level === undefined || level === null) return 'bg-gray-500'
  const numLevel = Number(level)
  if (numLevel > 70) return 'bg-green-500'
  if (numLevel > 30) return 'bg-yellow-500'
  return 'bg-red-500'
}

const getStatusClass = (status) => {
  if (status === 'charging') return 'text-green-400'
  if (status === 'discharging') return 'text-yellow-400'
  return ''
}

const getStatusIcon = (status) => {
  if (status === 'charging') return '⚡'
  return ''
}
</script>

<template>
  <StatusItem :icon="icons.battery">
    <div class="flex flex-col w-full">
      <div class="flex items-center justify-between w-full mb-1">
        <div class="flex-1 mr-2 bg-gray-800 rounded-full h-2.5 overflow-hidden">
          <div
            :class="[getBatteryColor(level)]"
            :style="{
              width: `${level || 0}%`,
            }"
            class="h-full transition-width duration-300"
          />
        </div>
        <span class="font-medium whitespace-nowrap status-item-value">{{ formatBatteryLevel(level) }}</span>
      </div>

      <div v-if="status" class="flex items-center">
        <span class="font-medium status-item-label" :class="getStatusClass(status)"> {{ status }} {{ getStatusIcon(status) }} </span>
      </div>
    </div>
  </StatusItem>
</template>

<style scoped>
.transition-width {
  transition: width 0.5s ease-in-out;
}
</style>
